import { render, staticRenderFns } from "./settlements.vue?vue&type=template&id=492466a8&scoped=true&"
import script from "./settlements.vue?vue&type=script&lang=js&"
export * from "./settlements.vue?vue&type=script&lang=js&"
import style0 from "./settlements.vue?vue&type=style&index=0&id=492466a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492466a8",
  null
  
)

export default component.exports